import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  font: "'Nunito', 'Open Sans', sans-serif",
  gridPoints: 8,
  colors: {
    black: '#1D1D1D',
    gray: '#C2C2C2',
    white: '#FFFFFF',
    blue1: '#0395CE',
    blue2: '#02719C',
    purple1: '#801280',
    purple2: '#4D0B4D',
    green1: '#40B27E',
    green2: '#2E805A',
    red1: '#C50111',
    red2: '#91010D',
    beige: '#FFEDDD',
  },
};
